import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
const terms = ['সাথে সাথেই সম্পূর্ণ রিফান্ড', 'কোনো প্রশ্ন করা হবে না', 'কোনো লুকানো শর্ত নেই', 'সব বোনাস আমাদের উপহার হিসেবে আপনারই থাকবে'];
export function Guarantee() {
  return <section id="guarantee" aria-labelledby="guarantee-heading" className="border-y border-celeste-500/25 bg-navy-900" data-id="element-69" data-mp="222wjc7wug0nm">
      <div className="mx-auto flex max-w-content flex-col gap-10 px-4 py-16 sm:px-6 lg:flex-row lg:gap-16 lg:py-20" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-70" data-mp="1x28vtw7tq1y5">
        <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-2xl border border-celeste-500/40 bg-navy-800" data-id="element-71" data-mp="14hh9k6mbc20h">
          <ShieldCheckIcon className="h-12 w-12 text-celeste-400" aria-hidden="true" data-id="element-72" data-mp="1edtzquinfxqh" />
        </div>
        <div className="max-w-2xl" data-id="element-73" data-mp="qnzqso1gatbi">
          <h2 id="guarantee-heading" className="font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[2rem]" data-id="element-74" data-mp="qn7x5irez5nv">
            ৭ দিনের ১০০% মানি-ব্যাক গ্যারান্টি
          </h2>
          <p className="mt-4 text-white/75" data-id="element-75" data-mp="oz04vzfpm8qf">
            আমরা সম্পূর্ণ আত্মবিশ্বাসী যে দ্য আর্জেন্টাইন মাইন্ডসেট চ্যালেঞ্জ, টাকা ও সাফল্য
            নিয়ে আপনার চিন্তাভাবনা বদলে দেবে। যদি কোনো কারণে ৭ দিনের মধ্যে আপনি সন্তুষ্ট না হন:
          </p>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-76" data-mp="12qohe3tvez7x">
            {terms.map(term => <li key={term} className="flex items-start gap-3 text-[15px] text-white/90" data-id="element-77" data-mp="12sr4og3n2e8y">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-celeste-400" aria-hidden="true" data-id="element-78" data-mp="62qkkue7slxz" />
                {term}
              </li>)}
          </ul>
          <p className="mt-6 text-white/70" data-id="element-79" data-mp="f0ako00ccc70">
            হাজারো শিক্ষার্থীর সাথে আমরা এই সিস্টেম পরীক্ষা করেছি। আমরা জানি এটি কাজ করে। আর
            সেটা নিজের টাকা দিয়েই আমরা সমর্থন করছি।
          </p>
          <p className="mt-4 font-display text-lg font-bold text-white" data-id="element-80" data-mp="1qfh6phfzm8tk">
            আপনার সাফল্যই আমাদের সাফল্য। ব্যাস।
          </p>
        </div>
      </div>
    </section>;
}